// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { SupportAlert } from '@/components/support-alert';
import {
  SupportErrorContext,
  SupportErrorContextValue,
} from '@/contexts/support-error-context';
import { PropsWithChildren, useState } from 'react';

interface SupportErrorState {
  isVisible: boolean;
  message: string;
}

export function SupportErrorProvider(props: PropsWithChildren) {
  const [state, setState] = useState<SupportErrorState>({
    isVisible: false,
    message: '',
  });

  const showSupportError = (message: string) => {
    setState({ isVisible: true, message });
  };

  const hideSupportError = () => {
    setState({ isVisible: false, message: '' });
  };

  const value: SupportErrorContextValue = {
    showSupportError,
    hideSupportError,
    isVisible: state.isVisible,
  };
  return (
    <SupportErrorContext.Provider value={value}>
      {props.children}
      {state.isVisible && (
        <SupportAlert
          message={state.message}
          style={{
            position: 'fixed',
            top: '20px',
            left: '20px',
            right: '20px',
            zIndex: 9999,
            maxWidth: '980px',
            margin: '0 auto',
          }}
          onClose={hideSupportError}
        />
      )}
    </SupportErrorContext.Provider>
  );
}
